export const ipAddress = {
  // dev: "54.218.78.156",
  // dev: "54.245.183.167",
 dev: 'https://pharcomm360.agilisiumtech.com:444'    // Live
  // dev: 'https://dev-pharcomm360.agilisiumtech.com:444'  // Test
};